import React from 'react';
import DollarPriceInput from '@wix/da-shared-react/pkg/DollarPriceInput';
import DollarInputController, {
  DollarInputControllerProps,
} from '../../_partials/DollarInputController';

export interface Props extends Omit<DollarInputControllerProps, 'render'> {}

const DollarInputField: React.FC<Props> = props => {
  return (
    <DollarInputController render={fieldProps => <DollarPriceInput {...fieldProps} />} {...props} />
  );
};
DollarInputField.displayName = 'DollarInputField';

export default DollarInputField;
